import Swiper from 'swiper'
import { Navigation, Autoplay, Pagination, EffectFade, FreeMode, Mousewheel } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'

let config

export const initSwiper = () => {
	const sliders = document.querySelectorAll('[data-swiper]')

	if (!sliders.length) return

	sliders.forEach((slider) => {
		const type = slider.getAttribute('data-swiper')
		const pagination = slider.querySelector('.swiper-pagination')
		const prevEl = slider.querySelector('.swiper-button-prev')
		const nextEl = slider.querySelector('.swiper-button-next')

		switch (type) {
			case 'latest-news':
				config = {
					loop: true,
					slidesPerView: 1.25,
					spaceBetween: 30,
					speed: 1000,
					grabCursor: true,
					modules: [FreeMode, Mousewheel],
					freeMode: {
						enabled: true,
					},
					breakpoints: {
						1025: {
							slidesPerView: 4,
							spaceBetween: 30,
						},
						651: {
							slidesPerView: 2.5,
							spaceBetween: 30,
						}
					}
				}
			break;
			case 'hof-slider':
				config = {
					loop: true,
					slidesPerView: 1.25,
					spaceBetween: 30,
					grabCursor: true,
					modules: [FreeMode, Mousewheel],
					freeMode: {
						enabled: true,
					},
					breakpoints: {
						1025: {
							slidesPerView: 4,
							spaceBetween: 30,
						},
						651: {
							slidesPerView: 2.5,
							spaceBetween: 30,
						}
					}
				}
			break;
			case 'testimonials':
				config = {
					loop: true,
					slidesPerView: 1,
					spaceBetween: 24,
					centeredSlides: true,
					grabCursor: true,
					modules: [Navigation],
					navigation: {
						nextEl,
						prevEl,
						addIcons: false
					},
					breakpoints: {
						1025: {
							centeredSlides: false,
							slidesPerView: 2.75,
							spaceBetween: 24,
						},
						651: {
							slidesPerView: 1.5,
							spaceBetween: 30,
						}
					}
				}
			break;
		}

		const swiper = new Swiper(slider, {...config })

	})
}